import { useEffect, useState } from 'react'

const useFetch = (url, loadingStatus) => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(loadingStatus);
    useEffect(() => {
        fetch(url)
            .then((res) => {
                if (!res.ok) {
                    throw new Error(
                        `HTTP error - status: ${res.status}`
                    )
                }
                return res.json()
            })
            .then((data) => {
                setData(data)
            })
            .catch((err) => {
                console.log(err.message);
            })
            .finally(() => {
                setLoading(false);
            })
            return () => {
                setData(null)
                // setLoading(true)
            }
    }, [url]);

    return [data, loading]
}

export default useFetch